import React from 'react';
import { Route, Switch } from 'react-router-dom';
import * as Unauth from '../../unauth/';

const TugaIframeLayout: React.FC<{}> = () => {
    return (
        <React.Fragment>
            <Switch>
                <Route render={() => <Unauth.TugaIframe />} />
            </Switch>
        </React.Fragment>
    );
};

export default TugaIframeLayout;
